"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentNoteTemplateGlobalId = void 0;
var AppointmentNoteTemplateGlobalId;
(function (AppointmentNoteTemplateGlobalId) {
    AppointmentNoteTemplateGlobalId["SOAP"] = "SOAP";
    AppointmentNoteTemplateGlobalId["SUMMARY"] = "SUMMARY";
    AppointmentNoteTemplateGlobalId["NEW"] = "NEW";
})(AppointmentNoteTemplateGlobalId = exports.AppointmentNoteTemplateGlobalId || (exports.AppointmentNoteTemplateGlobalId = {}));
//# sourceMappingURL=AppointmentNoteTemplateGlobalId.js.map